import { MULTIPLIER } from '../constants';

export const formatInputValue = value => {
  if (value === '' || value == null) {
    return '';
  }

  const numericValue = typeof value === 'number' ? value : Number(value);

  return Number.isNaN(numericValue) ? '' : numericValue * MULTIPLIER;
};
